import { from } from 'rxjs';
import moment from 'moment';
import { filter, take } from 'rxjs/operators';
import { logProgramChange } from '@shoflo/studio-redux/utils';
import { buildNewScene } from './utils/utils';
import { setProgram } from 'actions/Broadcast';
import * as SceneLayouts from 'constants/SceneLayouts';
import { GET_BROADCAST, BROADCAST_GET_SOURCES } from 'actions/Types';
import { shouldHaveFeature } from '@studio/feature.flags/featureFlags';

let gotBroadcast = false;
let gotSources = false;
const TWELVE_HOURS = 12;

/**
 * What does this middleware do?
 *
 * After loading the broadcast object and the sources for the broadcast, it checks to see if the broadcast is 'stale', i.e.
 * more than 12 hours old. If it is stale, it regenerates the program scene w/ new signed URLs from sceneLayers, sources state
 * and updates the program.
 *
 * @param {*} store
 */
export const updateStaleProgram = store => next => async action => {
  const { dispatch, getState } = store;

  const targetdActions = [
    `${GET_BROADCAST}_SUCCESS`,
    `${BROADCAST_GET_SOURCES}_SUCCESS`
  ];

  from([action])
    .pipe(
      filter($action => targetdActions.includes($action.type)),
      take(2)
    )
    .subscribe($action => {
      if (shouldHaveFeature('studio-disable-update-stale-program-middleware')) {
        return;
      }

      let {
        broadcast,
        attendeeMuteStatus,
        broadcastSources,
        program: currentProgram,
        brandingSettings
      } = store.getState();

      if ($action.type === `${GET_BROADCAST}_SUCCESS`) {
        gotBroadcast = true;
        broadcast = action.payload;
      }

      if ($action.type === `${BROADCAST_GET_SOURCES}_SUCCESS`) {
        gotSources = true;
        broadcastSources = action.payload;
      }

      broadcastSources = broadcastSources.sources || broadcastSources.items;

      if (gotBroadcast && gotSources) {
        const sceneLayers = broadcast.globalSceneLayers;
        const banners = broadcast.banners;

        // Confirm there is no current program
        const isThereCurrentProgram =
          currentProgram &&
          currentProgram.layers &&
          currentProgram.layers.length > 0;
        // If the last update to the broadcast was over 12 hours ago
        if (
          moment().diff(moment(broadcast.modifiedOn), 'hours') > TWELVE_HOURS &&
          broadcast.program &&
          !isThereCurrentProgram
        ) {
          const sceneLayouts = SceneLayouts;
          const scene = buildNewScene({
            sceneLayers,
            banners,
            broadcast,
            broadcastSources,
            sceneLayouts,
            attendeeMuteStatus,
            fonts: brandingSettings?.fonts
          });
          dispatch(setProgram(scene, action.isTransient));
          logProgramChange(getState, 'updateStaleProgram middleware');
        }
      }
    });

  return next(action);
};

export default updateStaleProgram;
